import {
  BrowserRouter,
  Link,
  matchPath,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Icon, Menu } from "semantic-ui-react";
import Topbar from "./components/Topbar";
import { useAuth } from "./contexts/AuthContext";
import layout from "./layout";
import AddTeam from "./screens/AddTeam";
import AddUser from "./screens/AddUser";
import Apps from "./screens/Apps";
import Login from "./screens/Login";
import NoAccess from "./screens/NoAccess";
import NotFound from "./screens/NotFound";
import TeamAdmin from "./screens/TeamAdmin";
import UpdateTeam from "./screens/UpdateTeam";
import UserAdmin from "./screens/UserAdmin";
import UserDetails from "./screens/UserDetails";
import Settings from "./screens/Settings";

const style = {
  wrapper: {
    minHeight: "100%",
  },
  app: {
    display: "flex",
  },
  sidebar: {
    minHeight: `calc(100vh - ${layout.topbarHeight})`,
    display: "flex",
    borderLeft: "none",
    borderTop: "none",
    borderBottom: "none",
    borderRadius: 0,
    minWidth: layout.sidebarWidth,
  },
  content: {
    width: "100%",
    height: `calc(100vh - ${layout.topbarHeight}`,
    overflowY: "scroll",
  },
};

const AppRoutes = () => {
  const { apiUser } = useAuth();

  const unauthenticatedRoutes = () => {
    return (
      <>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </>
    );
  };

  const authenticatedRoutes = () => {
    return (
      <Route path="/" element={<AuthLayout />}>
        {apiUser?.is_admin ? (
          <>
            <Route index element={<Navigate to="/users" />} />
            <Route path="/teams/create" element={<AddTeam />} />
            <Route path="/teams/:teamId" element={<UpdateTeam />} />
            <Route path="/teams" element={<TeamAdmin />} />
            <Route path="/users/create" element={<AddUser />} />
            <Route path="/users/:userId" element={<UserDetails />} />
            <Route path="/users" element={<UserAdmin />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/settings" element={<Settings />} />
          </>
        ) : (
          <Route index element={<NoAccess />} />
        )}
        <Route path="*" element={<NotFound />} />
      </Route>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Wrapper />}>
          {apiUser ? authenticatedRoutes() : unauthenticatedRoutes()}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

function Wrapper() {
  return (
    <div style={style.wrapper}>
      <Outlet />
    </div>
  );
}

function AuthLayout() {
  const { apiUser } = useAuth();

  return (
    <>
      <Topbar />
      <div style={style.app}>
        {apiUser?.is_admin && (
          <Menu
            inverted
            borderless
            icon="labeled"
            compact
            vertical
            style={style.sidebar}
          >
            <div style={{ flexGrow: "1" }}>
              <>
                {apiUser?.has_sidekick && apiUser?.sidekick_configured && (
                  <>
                    <MenuItem to="/users">
                      <Icon name="user" />
                      Sidekick Users
                    </MenuItem>
                    <MenuItem to="/teams">
                      <Icon name="users" />
                      Sidekick Teams
                    </MenuItem>
                  </>
                )}
                {apiUser?.has_connect && (
                  <>
                    <MenuItem to="/apps">
                      <Icon name="window restore outline" />
                      Connect Apps
                    </MenuItem>
                    <MenuItem to="/settings">
                      <Icon name="settings" />
                      Connect Settings
                    </MenuItem>
                  </>
                )}
              </>
            </div>
          </Menu>
        )}
        <div style={style.content}>
          <Outlet />
        </div>
      </div>
    </>
  );
}

function MenuItem({ to, children }) {
  const { pathname } = useLocation();

  return (
    <Menu.Item
      as={Link}
      to={to}
      active={matchPath(`${to}/*`, pathname) ? true : false}
    >
      {children}
    </Menu.Item>
  );
}

export default AppRoutes;
